export const ptMessageRows  = [
  {
    patient: 'Philips, Cammiee John',
    message:
      'Could you also mail or fax me a lab order? I need to do my A1C and recheck my lipids since I have...',
    from: 'Patient',
    date: '06/23/2026',
    status: 'Awaiting Clinic'
  },
  {
    patient: 'Willow, Gwen Marry',
    message:
      'Dr. reviewed your Mammogram and stated the Mammogram looks good, nothing to be concerned, however...',
    from: 'Clinic',
    date: '06/23/2026',
    status: 'Not Acknowledged'
  },
  {
    patient: 'Samuel, Sagar John',
    message:
      'Dr. reviewed your message and stated that he would like to prescribe Zolpidem 12.5 MG Extended Release.',
    from: 'Clinic',
    date: '06/21/2026',
    status: 'Completed'
  },
  {
    patient: 'Forte, Peter',
    message:
      'I have an appointment scheduled for 11:00 a.m. on June 18. I plan to keep that appointment.',
    from: 'Patient',
    date: '06/16/2026',
    status: 'Completed'
  },
  {
    patient: 'Samuel, Sagar John',
    message:
      'Dr. reviewed your message and stated that he would like to prescribe Zolpidem 12.5 MG Extended Release.',
    from: 'Clinic',
    date: '05/14/2026',
    status: 'Completed'
  },
  {
    patient: 'Forte, Peter',
    message:
      'I have an appointment scheduled for 11:00 a.m. on June 18. I plan to keep that appointment.',
    from: 'Patient',
    date: '05/02/2026',
    status: 'Completed'
  },
  {
    patient: 'Samuel, Sagar John',
    message:
      'Dr. reviewed your message and stated that he would like to prescribe Zolpidem 12.5 MG Extended Release.',
    from: 'Clinic',
    date: '04/30/2026',
    status: 'Completed'
  },
  {
    patient: 'Forte, Peter',
    message:
      'I have an appointment scheduled for 11:00 a.m. on June 18. I plan to keep that appointment.',
    from: 'Patient',
    date: '03/11/2026',
    status: 'Completed'
  },
  {
    patient: 'Samuel, Sagar John',
    message:
      'Dr. reviewed your message and stated that he would like to prescribe Zolpidem 12.5 MG Extended Release.',
    from: 'Clinic',
    date: '03/02/2026',
    status: 'Completed'
  },
  {
    patient: 'Forte, Peter',
    message:
      'I have an appointment scheduled for 11:00 a.m. on June 18. I plan to keep that appointment.',
    from: 'Patient',
    date: '02/24/2026',
    status: 'Completed'
  }
];